// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"b910471d","498":"518b1c98","513":"273368f5","787":"0853f540"}[chunkId] + ".chunk.js";
};